<template>
  <div id="BottomRight">
    <div id="pieChart" ref="pieChart"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'BottomRight',
  data() {
    return {
      pieChart: null
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      this.pieChart = echarts.init(this.$refs.pieChart)
      const option = this.getOption()
      this.pieChart.setOption(option, true)
      window.addEventListener('resize', () => {
        this.pieChart.resize()
      })
    },
    getOption() {
      let option = {
        color: [
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#D4FFFF' // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#02FFFE' // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          },
          '#0068FF'
        ],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'center',
          right: 0,
          orient: 'vertical',
          icon: 'circle',
          textStyle: {
            color: 'rgba(255, 255, 255, 100)',
            fontSize: 14
          }
        },
        series: [
          {
            name: '活跃用户占比',
            type: 'pie',
            left: -70,
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                formatter: '{d}%',
                show: true,
                fontSize: '40',
                color: '#fff'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 10, name: '未活跃用户' },
              { value: 90, name: '活跃用户' }
            ]
          }
        ]
      }
      return option
    }
  }
}
</script>

<style lang="scss" scoped>
#BottomRight {
  width: 100%;
  height: 100%;
  #pieChart {
    width: 100%;
    height: 100%;
  }
}
</style>
